export const num = (n?: number | null) => (n == null ? '—' : n.toLocaleString('en-US'));

export const limit = (n?: number | null) => (n == null ? '—' : n === -1 ? 'Unlimited' : n.toLocaleString('en-US'));

export function date(iso?: string | null) {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function dateTime(iso?: string | null) {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—'
    : d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function ago(iso?: string | null) {
  if (!iso) return 'never';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '—';
  const s = Math.round((Date.now() - t) / 1000);
  if (s < 0) return 'just now';
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  const d = Math.floor(s / 86400);
  if (d < 31) return `${d} day${d === 1 ? '' : 's'} ago`;
  const m = Math.floor(d / 30.4);
  if (m < 12) return `${m} month${m === 1 ? '' : 's'} ago`;
  const y = Math.floor(m / 12);
  return `${y} year${y === 1 ? '' : 's'} ago`;
}

export function daysUntil(iso?: string | null) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isNaN(t) ? null : Math.ceil((t - Date.now()) / 86400000);
}

export function bytes(n?: number | null) {
  if (n == null) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0, v = n;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

/** "tenant.plan_change" -> "Plan change" */
export function actionLabel(action: string) {
  const known: Record<string, string> = {
    'admin.login': 'Admin signed in', 'admin.logout': 'Admin signed out', 'admin.update_pin': 'Admin PIN changed', 'admin.sessions_revoked': 'Admin sessions signed out',
    'tenant.plan_change': 'Plan changed', 'tenant.upgrade': 'Plan changed', 'tenant.trial_extend': 'Trial extended', 'tenant.activate': 'Tenant reactivated',
    'tenant.deactivate': 'Tenant deactivated', 'tenant.delete': 'Tenant deleted', 'tenant.rename': 'Tenant renamed',
    'user.quarantine': 'User blocked', 'user.unquarantine': 'User unblocked', 'user.delete': 'User removed',
    'user.login': 'User signed in', 'notification.send': 'Notification sent', 'notification.withdraw': 'Notification withdrawn',
    'tenant.create': 'Tenant created by the team', 'tenant.invite_resend': 'Invite resent',
    'portal_account.block': 'Portal account blocked', 'portal_account.unblock': 'Portal account unblocked',
    'portal_account.sign_out': 'Portal account signed out', 'portal_account.delete': 'Portal account deleted',
    'assistant_security_event.review': 'FluxPilot event reviewed', 'assistant_security_event.mark_all_reviewed': 'FluxPilot events marked reviewed',
    'tenant.fluxpilot_enable': 'FluxPilot turned on', 'tenant.fluxpilot_disable': 'FluxPilot turned off',
  };
  if (known[action]) return known[action];
  const tail = action.split('.').slice(1).join(' ') || action;
  return tail.replace(/[_.]/g, ' ').replace(/^\w/, c => c.toUpperCase());
}
